import { useState } from "react";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import CustomGauge from "../EquipmentList/RadialChart";
import "./EngineMonitor.css";
const gauges = [
  { name: "Power",     value: 959,  unit: "kW", max: 2000 },
  { name: "Amperage",  value: 1388, unit: "A",  max: 2000 },
  { name: "Voltage",   value: 454,  unit: "V",  max: 1000 },
  { name: "Frequency", value: 59.9, unit: "Hz", max: 100  },
];

const ALARMS_LEFT = [
  "COMMON SHUTDOWN","EMERGENCY SHUTDOWN","SHUTDOWN FROM SAFETY SYS",
  "L/O LOW PRESS SHUTDOWN","HT CFW OUT HIGH T SHUTDOWN","CONTROL SOURCE FAIL",
  "GOVERNOR SOURCE FAIL","LO FLT DIFF .P.H","FO FLT DIFF .P.H",
  "LO SUMP TK L.I","LO SUMP TK L.H","F/O DRAIN BOX HIGH LEVEL",
  "PRE LO PRESS LOW","NO 1/2 G/E PSU COMMON ABN",
  "NO 1/2 G/E PSU BATT. CHARGER ALM","COMMON ABNORMAL ALARM",
].map(l => ({ label: l, ok: true }));

const SENSORS = [
  ["HT CFW IN TEMP","75","°C"],["HT CFW OUT TEMP","70","°C"],["HT CFW INLET PRESS","4.46","BAR"],
  ["LT CFW IN TEMP","28","°C"],["LT CFW OUT TEMP","31","°C"],["LT CFW INLET PRESS","2.90","BAR"],
  ["LO INLET TEMP","65","°C"],["LO INLET PRESS","4.59","BAR"],["LO FILTER INLET PRESS","5.12","BAR"],
  ["FO INLET TEMP","31","°C"],["FO INLET PRESS","7.17","BAR"],["FO FILTER INLET PRESS","7.16","BAR"],
  ["NON DRIVEN END TEMP","65","°C"],["CHARGE AIR OUT TEMP","55","°C"],
  ["CHARGE AIR INLET PRESS","1.82","BAR"],["STARTING AIR INLET PRESS","10.53","BAR"],
  ["T/C EXH GAS OUT","3.21","°C"],["T/C EXH GAS A IN","447","°C"],
  ["T/C EXH GAS B IN","447","°C"],["T/C L.O PRESS","3.04","BAR"],
].map(([label, value, unit]) => ({ label, value, unit }));

const SENSORS1 = [
  ["EXH. GAS MEAN","412","°C"],
  ["T/C RPM PICK UP","3100","RPM"],
  ["ENGINE SPEED","900","RPM"],
].map(([label, value, unit]) => ({ label, value, unit }));

const EXH_TEMP = [605, 613, 613, 612, 619, 624];
const EXH_DEV  = [7, 1, 1, 1, 7, 11];

const BOTTOM_ALARMS = [
  ["BOTH TACHO FAILURE TRIP","SAFETY TRIP CIRCUIT FAILURE","JET SYSTEM FAILURE","GOVERNOR FAIL"],
  ["T/C TACHO FAILURE","MONITORING SYSTEM FAILURE","TACHO FAILURE","OVERSPEED TRIP (1ST)"],
  ["OVERSPEED TRIP (2ND)","START FAILURE","STOP FAILURE","SAFETY SYSTEM FAILURE"],
  ["EXH GAS TEMP HIGH OR LOW","3.W PRE HEATER ON","TACHO B FAILURE",""],
];

export default function EngineMonitor() {
  const [alarms4]  = useState([]);
  const [alarms5]  = useState([]);
  const [alarms6]  = useState([]);
  const [alarms7]  = useState([]);
  const [alarms8]  = useState([]);
  const [alarms9]  = useState([]);
  const [alarms10] = useState([]);
  const [alarms11] = useState([]);
  const [alarms12] = useState([]);
  const [alarms13] = useState([]);
  const [alarms14] = useState([]);
  const [alarms15] = useState([]);
  const [alarms16] = useState([]);
  const [alarms17] = useState([]);
  const [alarms18] = useState([]);
  const [alarms19] = useState([]);

  return (
    <React.Fragment>
      <div className="page-content">
         <Container fluid className="">
     
       
          <Card className="em-card">

            {/* ── HEADER ── */}
            <CardHeader className="em-header">
              <div className="em-header-left">
               
                <div className="em-ship-info">
                  <span className="em-ship-name">ARK Prestige</span>
                  <span className="em-ship-sub">IMO 9665671 · BSM</span>
                </div>
              </div>
              <div className="em-nav">
                <button className="em-nb em-nb-active">Dashboard</button>
                <button className="em-nb">AMS</button>
                <button className="em-nb">Alerts</button>
                <button className="em-nb"><Link to="/alarms">Alarms</Link></button>
                <button className="em-nb">Voyage</button>
                <button className="em-nb">CCTV</button>
                <button className="em-nb">Status</button>
                <button className="em-nb">Master</button>
                <button className="em-nb">User</button>
                <span className="em-badge em-badge-red">10</span>
                <span className="em-badge em-badge-yellow">19</span>
                 <span className="em-ship-sub">UTC : 03:36:16</span>
                 
              </div>
            </CardHeader>

            <CardBody className="em-body">
              <Row className="g-2">

                {/* ── LEFT: alarm list ── */}
                <Col lg={2}>
                  <div className="em-glass em-panel">
                    <div className="em-section-hdr">
                      <span className="em-sec-label">G/E COMMON</span>
                      <span className="em-sec-label">GENERATORS</span>
                    </div>
                    <div className="em-gen-btns">
                      {[1,2,3,4].map(n => (
                        <button key={n} className="em-gen-btn">{n}</button>
                      ))}
                    </div>
                    {ALARMS_LEFT.map((item, i) => (
                      <div key={i} className="em-alarm-row">
                        <span>{item.label}</span>
                        <span className="em-dot em-dot-green" />
                      </div>
                    ))}
                  </div>
                </Col>

                {/* ── MIDDLE: sensor values ── */}
                <Col lg={3}>
                  <div className="em-glass em-panel em-panel-scroll">
                    {SENSORS.map((item, i) => (
                      <div key={i} className="em-sensor-row">
                        <span className="em-s-label">{item.label}</span>
                        <div className="em-s-val-group">
                          <span className="em-s-val">{item.value}</span>
                          <span className="em-s-unit">{item.unit}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>

                {/* ── RIGHT: gauges + exhaust + engine ── */}
                <Col lg={7}>
                  <div className="em-right-col">

                    {/* Gauges */}
                    <Container className="container em-glass em-gauges-row">
                      {gauges.map((g, i) => (
                        <div key={i} className="em-gauge-card">
                          <CustomGauge
                            value={g.value}
                            max={g.max}
                            label={g.value}
                            unit={g.unit}
                          />
                          <div className="em-gauge-name">{g.name}</div>
                        </div>
                      ))}
                    </Container>
  {/* Engine image */}
                    <div className="em-glass em-engine-section">
                      <img
                        src="/asset/windingtemp.png"
                        alt="Engine diagram"
                        className="em-engine-img"
                      />
                    </div>
                    {/* Exhaust */}
                    <div className="em-glass em-exh-wrap">
                      <div className="em-exh-left">
                        {SENSORS1.map((item, i) => (
                          <div key={i} className="em-sensor-row">
                            <span className="em-s-label">{item.label}</span>
                            <div className="em-s-val-group">
                              <span className="em-s-val">{item.value}</span>
                              <span className="em-s-unit">{item.unit}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="em-exh-right">
                        <div className="em-exh-title">EXH. GAS TEMP [°C]</div>
                        <div className="em-exh-title">EXH. GAS DEVIATION</div>
                        <div className="em-exh-grid">
                          {["NO.1","NO.2","NO.3","NO.4","NO.5","NO.6"].map((h,i) => (
                            <div key={i} className="em-exh-head">{h}</div>
                          ))}
                          {[alarms8,alarms9,alarms10,alarms11,alarms12,alarms13].map((arr, i) => (
                            <div key={i} className="em-exh-val">
                              {arr.length ? arr.map((it,j) => <span key={j}>{it.min_value}</span>) : EXH_TEMP[i]}
                            </div>
                          ))}
                          {[alarms14,alarms15,alarms16,alarms17,alarms18,alarms19].map((arr, i) => (
                            <div key={i} className="em-exh-dev">
                              {arr.length ? arr.map((it,j) => <span key={j}>{it.min_value}</span>) : `+${EXH_DEV[i]}`}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                  
                  </div>
                </Col>
              </Row>

              {/* ── BOTTOM ALARMS ── */}
              <Row className="mt-2 g-2">
                {[alarms4, alarms5, alarms6, alarms7].map((arr, col) => (
                  <Col key={col} lg={3}>
                    <div className="em-glass em-panel">
                      {arr.length
                        ? arr.map((item, i) => (
                            <div key={i} className="em-alarm-row">
                              <span>{item.description}</span>
                              <span className="em-dot em-dot-green" />
                            </div>
                          ))
                        : BOTTOM_ALARMS[col].map((label, i) => label ? (
                            <div key={i} className="em-alarm-row">
                              <span>{label}</span>
                              <span className="em-dot em-dot-green" />
                            </div>
                          ) : null)
                      }
                    </div>
                  </Col>
                ))}
              </Row>
            </CardBody>

          </Card>
    
      </Container>
      </div>
    </React.Fragment>
  );
}